import { useRef, useState } from 'react';

export const useAudio = () => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const playAudio = async (fileName) => {
        try {
            if (!fileName) return;
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
            const audio = new Audio();
            audioRef.current = audio;
            audio.src = `${process.env.REACT_APP_SERVER_URL}/api/audio/${fileName}`;
            audio.addEventListener('play', () => setIsPlaying(true));
            audio.addEventListener('pause', () => setIsPlaying(false));
            audio.addEventListener('ended', () => setIsPlaying(false));
            audio.addEventListener('error', (error) => {
                console.error('Audio playback error:', error);
                setIsPlaying(false);
            });
            await audio.play();
        } catch (error) {
            console.error('Error playing audio:', error);
            setIsPlaying(false);
        }
    };
    const stopAudio = () => {
        if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        }
    };
    return { 
        playAudio, 
        stopAudio, 
        isPlaying 
    };
};